import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import { Grid } from '@interstate/components/Grid';
import { useSelector } from 'react-redux';
import * as dealLockingSelectors from '@makemydeal/dr-dash-store/selectors/dealLockingSelectors';
import { useEffect, useRef, useState } from 'react';

export function LockWarning() {
    const isLockSupported = useSelector(dealLockingSelectors.isLockSupported);
    const isLocked = useSelector(dealLockingSelectors.getLockPaymentInputsInSVByDealType);

    const prevLockStateRef = useRef<boolean | null>(null);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        if (prevLockStateRef.current === null) {
            prevLockStateRef.current = isLocked;
            return;
        }

        if (prevLockStateRef.current !== isLocked) {
            setShowAlert(true);
            prevLockStateRef.current = isLocked;
        }
    }, [isLocked]);

    const handleClose = () => {
        setShowAlert(false);
    };

    if (!isLockSupported || !showAlert) return null;

    return (
        <Grid xs={12} padding="0" marginBottom="1rem">
            <Alert
                role="banner"
                type="info"
                displayCloseButton={true}
                data-testid="locking-alert-warning"
                onCloseClick={handleClose}
            >
                {isLocked ? (
                    <Typography variant="label-md">
                        Term, Rate and Credit Tier fields have been locked. Click the lock button to unlock.
                    </Typography>
                ) : (
                    <Typography variant="label-md">
                        Term, Rate and Credit Tier fields have been unlocked. Click the lock button to lock.
                    </Typography>
                )}
            </Alert>
        </Grid>
    );
}
